// extracted by mini-css-extract-plugin
export default {"mobile-pagination":"B6nenkpy8Tfm60U0bGme","mobilePagination":"B6nenkpy8Tfm60U0bGme","desktop-pagination":"Chh9rys5QhGvExOg2rjZ","desktopPagination":"Chh9rys5QhGvExOg2rjZ"};